import { GetStaticPaths, GetStaticProps } from 'next'

import initApollo, { API } from '../../api'

import { PAGES, GUIDE } from './queries'

import { ParsedUrlQuery } from 'querystring'

export const getStaticPaths: GetStaticPaths = async () => {
  const client = initApollo({})

  const { data } = await client.query<API.GuidePages>({
    query: PAGES,
  })

  const guides = data.libraryGuides?.nodes ?? []

  const paths = guides.map((guide) => `/guides/${guide.slug}`)

  return { paths, fallback: false }
}

interface Params extends ParsedUrlQuery {
  slug: string
}

export type Props = NonNullable<API.Guide['libraryGuide']>

export const getStaticProps: GetStaticProps<Props, Params> = async ({ params }) => {
  const client = initApollo({})

  const { data } = await client.query<API.Guide, API.GuideVariables>({
    query: GUIDE,
    variables: {
      slug: params!.slug,
    },
  })

  if (!data.libraryGuide) {
    return {
      notFound: true,
    }
  }

  return {
    props: data.libraryGuide,
  }
}
